const reviewSections = document.querySelectorAll('[data-gv-reviews]');

reviewSections.forEach((section) => {
  const widget = section.querySelector('[data-gv-reviews-widget]');
  const writeButton = section.querySelector('[data-gv-write-review]');
  if (!widget) return;

  const refreshState = () => {
    const reviewCountText = widget.querySelector('.jdgm-rev-widg__summary-text')?.textContent || '';
    const hasReviewNode = Boolean(widget.querySelector('.jdgm-rev, .jdgm-row-profile, .jdgm-rev-widg__reviews'));
    const numericCount = Number.parseInt(reviewCountText.replace(/[^0-9]/g, ''), 10) || 0;
    section.classList.toggle('has-reviews', hasReviewNode && numericCount > 0);
  };

  const observer = new MutationObserver(refreshState);
  observer.observe(widget, { childList: true, subtree: true, characterData: true });
  window.setTimeout(refreshState, 700);
  window.setTimeout(refreshState, 1800);

  writeButton?.addEventListener('click', () => {
    const judgeLink = widget.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-link.jdgm-write-rev-link');
    if (judgeLink instanceof HTMLElement) {
      section.classList.add('has-reviews');
      judgeLink.click();
      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
